var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateEstimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:cost-estimate-outline",
    clipPath: "url(#clip0_5894_14374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.09997 8.9H4.5333V10.1H5.09997V8.9ZM11.9 10.1H12.4666V8.9H11.9V10.1ZM9.6333 12.5H9.06663V13.7H9.6333V12.5ZM11.9 13.7H12.4666V12.5H11.9V13.7ZM5.09997 5.3H4.5333V6.5H5.09997V5.3ZM7.36663 6.5H7.9333V5.3H7.36663V6.5ZM11.9 1.1L12.3012 0.6752L12.1346 0.5H11.9V1.1ZM15.3 4.7H15.8666V4.4516L15.7012 4.2752L15.3 4.7ZM5.09997 10.1H11.9V8.9H5.09997V10.1ZM9.6333 13.7H11.9V12.5H9.6333V13.7ZM5.09997 6.5H7.36663V5.3H5.09997V6.5ZM14.1666 17.3H2.8333V18.5H14.1666V17.3ZM2.26663 16.7V2.3H1.1333V16.7H2.26663ZM2.8333 1.7H11.9V0.5H2.8333V1.7ZM14.7333 4.7V16.7H15.8666V4.7H14.7333ZM11.4988 1.5248L14.8988 5.1248L15.7012 4.2752L12.3012 0.6752L11.4988 1.5248ZM2.8333 17.3C2.68301 17.3 2.53888 17.2368 2.43261 17.1243C2.32634 17.0117 2.26663 16.8591 2.26663 16.7H1.1333C1.1333 17.1774 1.31241 17.6352 1.63122 17.9728C1.95003 18.3104 2.38243 18.5 2.8333 18.5V17.3ZM14.1666 18.5C14.6175 18.5 15.0499 18.3104 15.3687 17.9728C15.6875 17.6352 15.8666 17.1774 15.8666 16.7H14.7333C14.7333 16.8591 14.6736 17.0117 14.5673 17.1243C14.4611 17.2368 14.3169 17.3 14.1666 17.3V18.5ZM2.26663 2.3C2.26663 2.14087 2.32634 1.98826 2.43261 1.87574C2.53888 1.76321 2.68301 1.7 2.8333 1.7V0.5C2.38243 0.5 1.95003 0.689642 1.63122 1.02721C1.31241 1.36477 1.1333 1.82261 1.1333 2.3H2.26663Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5894_14374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEstimate);
export default __webpack_public_path__ + "static/media/create-estimate.031d6f66b00cf5bcddca599d969bbd46.svg";
export { ForwardRef as ReactComponent };